import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import updateLabelPosition from '../../__utils/iconLabelHelpers';

export default class Label extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labelPosition: this.props.position,
      containerPositionTop: 0,
      containerPositionLeft: 0,
    };

    this.labelRef = null;

    this.setLabelRef = element => {
      this.labelRef = element;
    };

    this.setContainerRef = element => {
      this.containerRef = element;
    };
  }

  componentDidMount() {
    this.updatePosition(this.props.position);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.position !== this.state.labelPosition) {
      this.updatePosition(nextProps.position);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.state.delayTimeout);
  }

  updatePosition = newPosition => {
    const container = this.containerRef;
    const containerRect = container.getBoundingClientRect();
    const position = updateLabelPosition(this.props.parent, container, this.labelRef, newPosition, this.props.maxWidth);
    this.setState({
      labelPosition: position,
      containerPositionTop: containerRect.top,
      containerPositionLeft: containerRect.left,
    });
  };

  showLabel = () => {
    this.updatePosition(this.state.labelPosition);

    this.labelRef.classList.add('uni-icon-label--is-shown', 'uni-icon-label--animate');
  };

  hideLabel = () => {
    // if the timeout was set, clear it so that subsequent
    // mouse enters show the label
    clearTimeout(this.state.delayTimeout);

    this.labelRef.classList.remove('uni-icon-label--is-shown', 'uni-icon-label--animate');
  };

  render() {
    const { children, label } = this.props;
    const { labelPosition } = this.state;
    const labelClasses = classnames('uni-icon-label', {
      [`uni-icon-label--${labelPosition}`]: labelPosition,
    });

    return (
      <div className="uni-icon-label__wrapper" onMouseEnter={this.showLabel} onMouseLeave={this.hideLabel}  ref={this.setContainerRef}>
        {children}
        <div className={labelClasses} ref={this.setLabelRef}>{label}</div>
      </div>
    );
  }
}

Label.propTypes = {
  children: PropTypes.any,
  label: PropTypes.string,
  labelPosition: PropTypes.oneOf([ 'top', 'bottom', 'right', 'left']),
};

Label.defaultProps = {
  position: 'bottom',
};



// WEBPACK FOOTER //
// ./src/icon/__partials/label.jsx